module.exports = __webpack_public_path__ + "img/e197be7.jpg";